/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ slug: NonNullable<unknown> }} Fw_Pub_DoneInputs */

const en_fw_pub_done = /** @type {(inputs: Fw_Pub_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Published as /templates/${i?.slug}`)
};

const id_fw_pub_done = /** @type {(inputs: Fw_Pub_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Terbit sebagai /templates/${i?.slug}`)
};

/**
* | output |
* | --- |
* | "Published as /templates/{slug}" |
*
* @param {Fw_Pub_DoneInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_pub_done = /** @type {((inputs: Fw_Pub_DoneInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Pub_DoneInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_pub_done(inputs)
	return en_fw_pub_done(inputs)
});